<template>
  <div>
    <v-row>
      <v-col cols="2">
        <div style="display: flex; gap: 16px">
          <div class="titleContainer">Open issues</div>
        </div>
      </v-col>
      <v-col cols="10">
        <div style="display: flex; gap: 16px">
          <v-icon @click=getFilters()>mdi-filter-outline</v-icon>
        </div>
      </v-col>
    </v-row>

    <div style="white-space: nowrap">
      <!-- <ButtonGroup
        :items="limit"
        text="text"
        value="value"
        multiple="true"
        returnObject="false"
        @item-selected="itemSelected"
      />
      <ButtonGroup
        class="ml-7"
        :items="selectionType"
        text="text"
        value="value"
        multiple="true"
        returnObject="false"
        @item-selected="itemSelected"
      /> -->
      <div style="display: flex; gap: 16px">
        <v-row>
          <v-col cols="3">
            <v-switch color="primary" density="compact" v-model="switchGroup.issues" label="Issues"
              @change="handleSwitchChange('issues')" />
          </v-col>
          <v-col cols="3">
            <v-switch color="primary" density="compact" v-model="switchGroup.estimate" label="Estimate"
              @change="handleSwitchChange('estimate')" />
          </v-col>
          <v-col cols="3">
            <v-switch color="primary" density="compact" v-model="switchGroup.quantity" label="Quantity"
              @change="handleSwitchChange('quantity')" />
          </v-col>
        </v-row>
      </div>

      <div v-if="getFilter" style="display: flex; gap: 12px">
        <v-row>
          <v-col cols="3">
            <AutoComplete :items="workSpaceData" item-value="id" item-title="name" density="compact"
              placeholder="Work Space" v-model="switchGroup.work_space_id" :multiple="true"
              @update:modelValue="selectItem" :disabled="showReadOnly" />
          </v-col>
          <v-col cols="3">
            <AutoComplete :items="projects" item-value="id" item-title="name" density="compact" placeholder="Projects"
              v-model="switchGroup.project_id" :multiple="true" @update:modelValue="selectItem"
              :disabled="showReadOnly" />
          </v-col>
          <v-col cols="3">
            <AutoComplete :items="subCategories" item-value="id" item-title="name" density="compact"
              placeholder="Sub Category" v-model="switchGroup.sub_category_id" :multiple="true"
              @update:modelValue="selectItem" :disabled="showReadOnly" />
          </v-col>
          <v-col cols="3">
            <AutoComplete :items="stageData" item-value="code" item-title="name" density="compact" placeholder="Stage"
              v-model="switchGroup.stage" :multiple="true" @update:modelValue="selectItem" :disabled="showReadOnly" />
          </v-col>

          <!-- <v-col cols="3">            
            <DatePicker
              @update:modelValue="getExceptionData"
              :data="formData.created"
              :selectionMode="'range'"
              :placeholder="'Date'"
              @selectDate="selectDate($event)"
            />
          </v-col> -->

          <v-col cols="3">
            <AutoComplete :items="dateCount" item-value="id" item-title="name" density="compact" placeholder="Past Due"
              v-model="switchGroup.past_due" @update:modelValue="selectItem" :disabled="showReadOnly" />
          </v-col>
        </v-row>
      </div>
      <div v-else></div>
      <div class="mainContent">
        <div style="display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 10px">
          <div v-for="(item, index) in estimate" :key="index">
            <button :class="{
              active: item.active,
              'active-button1': item.active,
              defaultBtn: !item.active,
            }" @click="selectItem(item, 'minutes_since_created', index)" class="estimate">
              {{ item.value }}
            </button>
          </div>

          <div v-for="(priority, index) in priorityData" :key="index">
            <button :class="{
              active: priority && priority.active,
              'active-button': priority && priority.active,
              defaultBtn: !(priority && priority.active),
            }" @click="selectItem(priority, 'priority')" class="priority">
              {{ priority.display_value }}
            </button>
          </div>
        </div>
      </div>

      <!--  <div v-for="(issueType, index) in issueTypeData" :key="index">
            <button :class="issueType.active ? 'active' : 'defaultBtn'" @click="selectItem(issueType, 'issueType')"
                class="issueType">{{ issueType.name }}</button>
        </div> -->
    </div>
  </div>
</template>

<script>
// import { ButtonGroup } from "@tiburadev/vue-comp";
import EnumService from "@/api/service/Enum/EnumService";
import AutoComplete from "@/components/ui/AutoComplete.vue";
import StageService from "@/api/service/Stage/StageService";
import commonService from "@/common.service";
import DashboardService from "@/api/service/Dashboard/DashboardService.js";



export default {
  components: {
    AutoComplete,
  },
  data() {
    return {
      limit: [
        { text: "Spend", value: "spend" },
        { text: "Required", value: "required" },
      ],
      selectedTime: null,
      selectTimeData: [],
      selectionType: [
        { text: "Issues", value: "issues" },
        { text: "Hours", value: "hours" },
      ],
      estimate: [
        { value: "30m", active: false, data_value: "30" },
        { value: "1 hr", active: false, data_value: "60" },
        { value: "2 hr", active: false, data_value: "120" },
        { value: "4 hr", active: false, data_value: "240" },
        { value: "8 hr", active: false, data_value: "480" },
        { value: ">8", active: false, data_value: ">480" },
      ],
      priorityData: [],
      formData: {},
      selectedPriorities: [],
      coupleButton1: "spend",
      coupleButton2: "issues",
      stageData: [],
      workSpaceData: [],
      projects: [],
      subCategories: [],
      selectedDuration: null,
      dateCount: [],
      getFilter: false,
      value: [0, 5],
      switchGroup: {
        issues: true,
        estimate: false,
        quantity: false,
      },
    };
  },
  created() {
    this.getExceptionData();
    this.getPriorityData();
    this.getStageData()
    this.getWorkSpaceData()
    this.getProjects()
    this.getsubCategories()
    this.generateDays();

  },
  methods: {

    // ... generate days ...
    generateDays() {
      this.dateCount = [];
      for (let i = 1; i <= 30; i++) {
        this.dateCount.push({ id: i, name: `${i} Days` });
      }
      this.dateCount = [...this.dateCount, { id: 31, name: '30 days aboves' }]
    },

    // ... filter icon ...
    getFilters() {
      this.getFilter = !this.getFilter;
    },

    // ... stage service ...
    getStageData() {
      StageService.findAll().then((response) => {
        this.stageData = response && response.length > 0 ? response : []
      }).catch(e => {
        console.log(e)
      })
    },

    // ... workspace service ...
    getWorkSpaceData() {
      commonService.getTableData({ tableName: 'work_spaces' }).then((response) => {
        this.workSpaceData = response && response.length > 0 ? response : []
      }).catch(e => {
        console.log(e)
      })
    },

    // ... projects service ...
    getProjects() {
      commonService.getTableData({ tableName: 'projects' }).then((response) => {
        this.projects = response && response.length > 0 ? response : []
      }).catch(e => {
        console.log(e)
      })
    },
    getsubCategories() {
      commonService.getTableData({ tableName: 'sub_categories' }).then((response) => {
        response.forEach(f=>{
          f.name = f.code ? `${f.code}-${f.name}`:f.name
        })
        this.subCategories = response && response.length > 0 ? response : []
      }).catch(e => {
        console.log(e)
      })
    },
    selectDate($event) {
      this.formData.created = $event;
      // alert("hiii")
      // alert($event)
      // this.formData.created = moment($event).format('DD-MM-YYYY')
      // this.formData = {...this.formData}
      // console.log(this.formData,"mmmmmmmm333")
      this.getExceptionData();
    },

    async getExceptionData() {
      let res = await DashboardService.getExceptionData(this.formData);
      this.data = res && res.data && res.data.data ? res.data.data : {};
      if (this.data && this.data.data && this.data.data.length > 0) {
        for (let i = 0; i < this.data.data.length; i++) {
          this.data.data[i].open =
            this.data.data[i]["open"] +
            this.data.data[i]["pending"] +
            this.data.data[i]["assigned"] +
            this.data.data[i]["inprogress"];
          this.data.data[i].closed =
            this.data.data[i]["closed"] + this.data.data[i]["completed"];
        }
      }
      console.log(this.data.data, "Data....");

      this.$forceUpdate();
    },

    itemSelected($item) {
      this.selectedItem = $item;
    },
    handleSwitchChange(type) {
      // If one switch is turned on, turn off the other
      if (type === "issues") {
        this.switchGroup.estimate = false;
        this.switchGroup.issues = true;
        this.switchGroup.quantity = false;
      } else if (type === "estimate") {
        this.switchGroup.issues = false;
        this.switchGroup.estimate = true;
        this.switchGroup.quantity = false;
      } else if (type === "quantity") {
        this.switchGroup.issues = false;
        this.switchGroup.quantity = true;
        this.switchGroup.estimate = false;
      }

      this.$emit("switch-group-change", { type, value: this.switchGroup });
    },
    selectItem(item, group, index) {
      let sendData = {};

      if (group === "priority") {
        item.active = !item.active;
        if (item.active) {
          this.selectedPriorities.push(item.data_value);
        } else {
          const index = this.selectedPriorities.indexOf(item.data_value);
          if (index !== -1) {
            this.selectedPriorities.splice(index, 1);
          }
        }
      } else if (group == "minutes_since_created") {
        this.estimate[index].active = !this.estimate[index].active
        sendData.minutes_since_created = this.estimate.filter(k => k.active)
      }

      sendData.priority = this.selectedPriorities;
      sendData.stage = this.switchGroup.stage;
      sendData.work_space_id = this.switchGroup.work_space_id;
      sendData.sub_category_id = this.switchGroup.sub_category_id;
      sendData.project_id = this.switchGroup.project_id;
      sendData.past_due = this.switchGroup.past_due
      this.$emit("Filter-clicked", sendData);
    },
    // ... other methods ...

    async getPriorityData() {
      try {
        let res = await EnumService.findAllDomain({ domain: "PRIORITY" });
        this.priorityData = res;
        this.priorityData.map((k) => (k.active = false));
      } catch (e) {
        this.priorityData = [];
      }
    },
  },
};
</script>

<style scoped>
.titleContainer {
  white-space: nowrap;
  font-size: 18px;
  font-weight: 700;
}

.activeBtn {
  font-size: 12px;
  font-weight: 400;
  width: 68px;
  height: 25px;
  border-radius: 4px;
  background: #d9d9d9;
}

.mainContent {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.defaultBtn {
  white-space: nowrap;
  text-transform: capitalize;
  color: #000;
  font-size: 10px;
  font-weight: 700;
  width: fit-content;
  padding: 0px 15px;
  height: 24px;
  border-radius: 4px;
  opacity: 0.5;
}

.estimate {
  border: 2px solid #ffbe65;
  background: #f9ecda;
}

.priority {
  border: 2px solid #0cb99a;
  background: #d1ffbd;
}

.issueType {
  border: 2px solid #240cb9;
  background: #d3cdf8;
}

.active {
  text-transform: capitalize;
  color: #000;
  font-size: 10px;
  font-weight: 700;
  width: fit-content;
  padding: 0px 15px;
  height: 24px;
  border-radius: 4px;
  opacity: 1;
}

.active-button {
  /* Style for the active button */
  font-weight: bold;
  background: #d1ffd5;
  /* Example background color for the active button */
  color: #000000;
  /* Example text color for the active button */
}

.active-button1 {
  /* Style for the active button */
  font-weight: bold;
  background: #f9a27d;
  /* Example background color for the active button */
  color: #000000;
  /* Example text color for the active button */
}

.range {
  padding-top: 0px;
  padding-bottom: 0px;
}

>>>.v-btn.v-btn--density-compact {
  height: 28px !important;
}
</style>
